<div class="messagesWrapper" [style.backgroundColor]="getBgColorStyle()" [class.leftShadow]="menuShown" (click)="click();">

    <div class="circle">{{ notifications.length }}</div>

    <div id="hd-element-msg-wrapper"
         class="messagesTable"
         [style.width]="getWidth()"
         [style.display]="getDisplayedStyle()">
        @for (notification of notifications; track notification; let i = $index) {
            <elem-msg-line-head
                class="headMessage"
                [notification]="notification"
                [first]="i === 0"></elem-msg-line-head>
        }
    </div>

</div>

